import { useAxiosClient } from '../hooks';
import { createQueryKey } from '../utils';
import sanitizeParams from './sanitizeParams';
import useQuery from './useQuery';
export default function useCount(variant, basePath, params, options) {
  const axiosClient = useAxiosClient();
  async function queryFn() {
    var _response$data;
    const url = variant.replace('{basePath}', basePath);
    const response = await axiosClient.get(url, {
      params: sanitizeParams(params)
    });
    const data = ((_response$data = response.data) == null ? void 0 : _response$data.response) || response.data || [];
    return (data == null ? void 0 : data.length) || 0;
  }
  const queryKey = createQueryKey(basePath, variant, params);
  const query = useQuery(queryKey, queryFn, options);
  return query;
}